import Spinner from "../../../../components/Spinner.jsx";
import {useTranslation} from "react-i18next";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import Button from "../../../../components/Button.jsx";
import Select from "react-select";
import useDownloadState from "../../../../api/utilities/useDownloadState.js";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import googleLogo from "../../../../images/login/g.svg";

export default function GoogleIntegrationForm({project, projectIntegration}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let customerClientDefaultValues = [];
    let customerClientOptions = [];

    for (let customerClient of projectIntegration?.googleIntegrationCustomerClients ?? []) {
        customerClientOptions.push({
            customerId: customerClient.customerId,
            customerClientId: customerClient.customerClientId,
            value: customerClient.customerId + customerClient.customerClientId,
            label: '[' + customerClient.customerClientId + '] ' + customerClient.name
        });

        if (customerClient.enabled) {
            customerClientDefaultValues.push({
                customerId: customerClient.customerId,
                customerClientId: customerClient.customerClientId,
                value: customerClient.customerId + customerClient.customerClientId,
                label: '[' + customerClient.customerClientId + '] ' + customerClient.name
            });
        }
    }

    let [selectedCustomerClients, setSelectedCustomerClients] = useState(customerClientDefaultValues);

    const {context, getAuthorityConfiguration, resetCurrentUserProjects} = useContext(GlobalContext);

    let redirectToLogin = () => {
        let oAuthUrl = new URL(import.meta.env.VITE_AUTHORITY_URL);
        oAuthUrl.pathname = '/api/v1/project/integrations/google';

        let query = new URLSearchParams({
            authorization: context.currentIdentity?.token,
            projectId: project.id,
        });

        if (projectIntegration?.id) {
            query.set('integrationId', projectIntegration.id);
        }

        oAuthUrl.search = query.toString();

        window.location.href = oAuthUrl.toString();
    };

    useEffect(() => {
        if (!projectIntegration) {
            setTimeout(
                () => redirectToLogin(),
                600, // so it looks we actually do something too :D
            )
        }
    }, []);

    let [state, setDownloading] = useDownloadState();

    let saveCustomerClients = () => {

        let customerClientIds = [];

        for (let customerClientOption of selectedCustomerClients) {
            customerClientIds.push(customerClientOption.customerClientId);
        }


        setDownloading(true);
        new ProjectIntegrationsApi(getAuthorityConfiguration())
                .chooseGoogleCustomerClients({
                projectId: project.id,
                integrationId: projectIntegration.id,
                requestBody: customerClientIds
            })
            .then(() => {
                resetCurrentUserProjects();
            })
            .finally(() => setDownloading(false))
    };

    if (!projectIntegration) {
        return (
            <div>
                <Spinner size={'spinner-large'} className={'mx-auto'}/>
                <p className={'text-center mt-4'}>{t('redirecting')}...</p>
            </div>
        );
    }

    // noinspection JSValidateTypes
    return (
        <LoadingComponent loading={state.downloading}>
            <div className={'flex flex-col gap-4'}>
                <div className={'flex gap-6 justify-start items-center'}>
                    <div className={'w-3/12 text-right'}>{t('project.meta.re-authorize')}:</div>
                    <div className={'w-36'}>
                        <Button
                            className={
                                'rounded cursor-pointer select-none social-login-btn'
                            }
                            onClick={() => redirectToLogin()}
                        >
                            <div className={'w-full px-2 gap-2 p-1'}>
                                <div className={'w-28'}>
                                    <img src={googleLogo} alt="Google" className="h-[20px] w-[20px]"/>
                                </div>
                                <div>{t('project.integration-connect-button')}</div>
                                </div>
                        </Button>
                    </div>
                </div>

                <div className={'w-full mt-6'}>
                    {t('project.google.enabled-client-customers')}:
                </div>

                <div className={'w-10/12 mx-auto'}>
                    <Select
                        defaultValue={customerClientDefaultValues}
                        isMulti
                        name="colors"
                        options={customerClientOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={setSelectedCustomerClients}
                    />
                </div>

                <div className={'w-10/12 mx-auto text-right'}>
                    <Button
                        className={'button-primary'}
                        onClick={() => saveCustomerClients()}
                    >
                        {t('project.google.save-customer-clients')}
                    </Button>
                </div>

            </div>
        </LoadingComponent>
    );
}
